angular.
module("dx.webapp.datetimeinput").
directive("dxTimeinput", function timeinputDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			time: "=",
			onChange: "<",
		},
		templateUrl: "tmpl/datetimeinput/timeinput-directive.html",
		controller: "DxTimeinputController",
		link: link,
	};

	function link($scope) {
		$scope.minutes = (function calcMin() {
			var results = [];

			for (var i = 0; i <= 59; i += 5) {
				results.push(i);
			}

			return results;
		}());

		$scope.hours = (function calcHour() {
			var results1 = [];

			for (var j = 0; j <= 23; j++) {
				results1.push(j);
			}

			return results1;
		}());
	}
});
